import { MaterializeAction } from 'angular2-materialize';
import {
    Component,
    OnInit,
    AfterViewInit,
    OnDestroy,
    ViewChildren,
    ElementRef,
    ViewChild
} from '@angular/core';
import {
    FormBuilder,
    FormGroup,
    FormArray,
    Validators,
    FormControlName
} from '@angular/forms';

import { Subscription, ISubscription } from 'rxjs/Subscription';
import { IProject, IPRoductionOffice, IProductionContact, IProjectContact } from './project.model';
import { GenericValidator } from "../shared/generic-validator";
import { ProjectService } from './project.service';
import { ActivatedRoute, Router, CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { AppService } from '../app.service';
import { ProjectValidator } from './project.validator';
import * as $ from 'jquery';
import { DatePipe } from "@angular/common";
import { Guid, SharedUtils,DateUtils } from '../shared/utils';
import { NotificationsService, Notification } from '../shared/helper-components/index'

import { ProjectComponent } from './project.component';
import { FormControl } from '@angular/forms';
import { MessageBrokerService, ComponentCanDeactivate, AuthService } from '../shared/core/index';
import { ProjectItem } from './projectItem';
import { EventEmitter, HostListener } from '@angular/core';
import { ILookup } from '../shared/lookup';
import { CIDocument, MassUpdateData } from "../clearance-item/clearance-item.model";
import { ClearanceItemAssetManagerComponent } from '../clearance-item/asset-management/clearance-item-asset-manager.component';
import { GlobalErrorHandler } from '../shared/core/error-handler';
import { ModalPromptComponent } from '../shared/helper-components/modal-prompt.component';
import { ModalPromptService, PromptOptions } from '../shared/helper-components/modal-prompt.service';
import { UserDepartmentService } from '../user-department/user-department.service';
import { IDepartment, IUserDepartment } from '../user-department/user-department.model';

declare var Materialize: any;

@Component({
    selector: 'project-detail',
    template: require('./project-detail.component.html')

})

export class ProjectDetailComponent implements OnInit, AfterViewInit, OnDestroy, ComponentCanDeactivate {

    @ViewChild('documentAsset') documentComponent: ClearanceItemAssetManagerComponent;
    @ViewChildren(FormControlName, { read: ElementRef }) formInputElements: ElementRef[];

    private validationMessages: { [key: string]: { [key: string]: string } };
    private genericValidator: GenericValidator;

    pageTitle: string = 'Project Edit';
    errorMessage: string;
    projectForm: FormGroup;
    project: IProject = new IProject();
    sub: Subscription;
    error: string = '';
    SaveLabel: string = 'Save';
    // Use with the generic validation message class
    displayMessage: { [key: string]: string } = {};
    titles: ILookup[];
    params = []
    documents: CIDocument[] = [];
    massUpdateData: MassUpdateData;
    openedProject: ProjectItem;
    userDepartments: IDepartment[];

    constructor(private _projectService: ProjectService,
        private _appService: AppService,
        private _fb: FormBuilder,
        private _route: ActivatedRoute,
        private _router: Router,
        private _notificationsService: NotificationsService,
        private _messageBrokerService: MessageBrokerService,
        private _errorHandler: GlobalErrorHandler,
        private _prompt: ModalPromptService,
        private _userDepartmentService: UserDepartmentService,
        private _authService: AuthService,
    ) {

        // Defines all of the validation messages for the form.
        // These could instead be retrieved from a file or database.
        this.validationMessages = {
            name: {
                required: 'Please Enter the Project Name.',
                maxlength: 'Project Name Cannot be Longer than 255 Characters',
                projectTaken: 'Project Name is Already Taken'
            },
            keyCode: {
                required: 'Please Enter the Key Code for the Project.',
                minlength: 'Key Code Must be at Least 2 Characters Long',
                maxlength: 'Key Code Cannot be Longer than 4 Characters',
                projectTaken: 'Key Code is Already Taken'
            }
        };

        // Define an instance of the validator for use with this form, 
        // passing in this form's set of validation messages.
        this.genericValidator = new GenericValidator(this.validationMessages);
    }

    //this to keep track of each default selected prod office or contact
    currentProductionOffice: string = Guid.MakeNew().ToString();
    currentProductionContact: string = Guid.MakeNew().ToString();
    currentProjectContact: string = Guid.MakeNew().ToString();

    //it persists the default prod office or contact onto the form
    defaultProductionOffice: FormControl;
    defaultProductionContact: FormControl;
    defaultProjectContact: FormControl;

    promptOptions: PromptOptions = {header: 'Delete Project', body: ''};
    promptSubscription: ISubscription;

    openModal() {
        this.promptOptions.body = 'Are you sure you want to delete \'' + this.project.name + '\'?';
        
        this.promptSubscription = this._prompt.openModal(null, true, this.promptOptions).first()
        .subscribe(
            answerWasYes=> {
                if(answerWasYes){
                    this.deleteProject(this.project.id);
                }
        });
    }

    ngOnInit(): void {

        this.projectForm = this._fb.group({
            id: '',
            name: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(255)], ProjectValidator.checkProjectName(false)],
            keyCode: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(4)], ProjectValidator.checkProjectName(true)],
            wprBillingCode: '',
            wrapDate: null,
            startDate: null,
            releaseDate: null,
            productionOffices: this._fb.array([this.initProductionOffice(this.currentProductionOffice, true)]),
            productionContacts: this._fb.array([this.initProductionContacts(this.currentProductionContact, true)]),
            projectContacts: this._fb.array([this.initProjectContacts()]),
            comments: '',
            documents: this._fb.array([]),
            department: ''
        });

        this.defaultProductionOffice = new FormControl();
        this.projectForm.addControl('defaultProductionOffice', this.defaultProductionOffice);
        this.defaultProductionContact = new FormControl();
        this.projectForm.addControl('defaultProductionContact', this.defaultProductionContact);
        this.defaultProjectContact = new FormControl();
        this.projectForm.addControl('defaultProjectContact', this.defaultProjectContact);

        //we'd like to know the 'current'/valid project (especially when 'adding' a new project to revert in case there is a change of mind)
        this.subScribeProjectNameChanges();

        // Read the product Id from the route parameter
        this.sub = this._route.params.subscribe(
            params => {
                let id = params['projectId'];
                this.getDepartments(id);
                if (id) {
                    this.getProject(id);
                } else {
                    this.getLookups()
                    this.pageTitle = 'New Project';
                    let p = new ProjectItem('', '[Adding New Project]')
                    this._messageBrokerService.setCurrentProject(p);
                }
            }
        );

    }

    ngOnDestroy(): void {
        this.sub.unsubscribe();
        if (this.promptSubscription  && !this.promptSubscription.closed)
            this.promptSubscription.unsubscribe();
        //the following is to put back the previous project in case nothing gets changed when a new one is attempted to ad
        //if project.id is not set, it means the project was not saved (and it's NOT an existing one)
        if (!this.project.id){
            this._messageBrokerService.setCurrentProject(this.openedProject);
        }
    }

    ngAfterViewInit() {

        SharedUtils.RemoveTooltipIfNeeded();

        this.initMaterial();

        //Watch for the blur event from any input element on the form.
        let controlBlurs: Observable<any>[] = this.formInputElements
            .map((formControl: ElementRef) => Observable.fromEvent(formControl.nativeElement, 'blur'));

        //
        this.defaultProductionOffice.valueChanges.subscribe(data => {
            // console.log('this.defaultProductionOffice.valueChanges: >> ' + data);
            this.currentProductionOffice = data;
        });

        this.defaultProductionContact.valueChanges.subscribe(data => {
            // console.log('this.defaultProductionContact.valueChanges: >> ' + data);
            this.currentProductionContact = data;
        });

        this.defaultProjectContact.valueChanges.subscribe(data => {
            // console.log('this.defaultProjectContact.valueChanges: >> ' + data);
            this.currentProjectContact = data;
        });

        //Merge the blur event observable with the valueChanges observable
        Observable.merge(this.projectForm.valueChanges, ...controlBlurs)
            .debounceTime(500)
            .subscribe(value => {
                this.displayMessage = this.genericValidator.processMessages(this.projectForm);
            });

        this.animate();
        $('.picker').attr('tabindex',-1);
        $('.picker__input').attr('tabindex',-1);
       
        SharedUtils.FixFlickering();
    }

    animate(){
        $('.main-container').addClass('animated bounceInUp');
        $('.main-container').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function () {
            $('.main-container').removeClass('animated bounceInUp');
        });
    }

    @HostListener('window:beforeunload')
    canDeactivate(): boolean {
        let isFormClean = !this.projectForm.dirty;
        return isFormClean;
    }

    subScribeProjectNameChanges(): void {
        this._messageBrokerService.getCurrentProject().subscribe((project: ProjectItem) => {
            if (project != null) {
                this.openedProject = project;
                if (!project.ProjectId) {
                    console.error('Could not detect an opened project!... ');
                }
            }
        }).unsubscribe();
    }

    get productionOffices(): FormArray {
        return <FormArray>this.projectForm.get('productionOffices');
    }

    get productionContacts(): FormArray {
        return <FormArray>this.projectForm.get('productionContacts');
    }

    get projectContacts(): FormArray {
        return <FormArray>this.projectForm.get('projectContacts');
    }

    initProductionContacts(primaryId: string = Guid.MakeNew().ToString(), selected: boolean = false): FormGroup {
        return this._fb.group({
            id: primaryId,
            primarypc: primaryId,
            title: '',
            name: '',
            phoneNumber: '',
            phoneNumber2: '',
            phoneNumber3: '',
            email: ['',[Validators.pattern('[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+')]],
        });
    }

    initProductionOffice(primaryId: string = Guid.MakeNew().ToString(), selected: boolean = false): FormGroup {
        return this._fb.group({
            id: primaryId,
            primary: primaryId,
            entity: '',
            address: '',
            phoneNumber: ''
        });

    }

    initProjectContacts(primaryId: string = Guid.MakeNew().ToString(), selected: boolean = false): FormGroup {
        return this._fb.group({
            id: primaryId,
            primarypo: primaryId,
            name: '',
            title: '',
            email: ['',[Validators.pattern('[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+')]],
            emailNotification: false,
            selected : false,
            phoneNumber:''
        });
    }

    initProjectContactsAdded(primaryId: string = Guid.MakeNew().ToString(), selected: boolean = false): FormGroup {
        return this._fb.group({
            id: primaryId,
            primarypo: primaryId,
            name: '',
            title: 'Project Contact title',
            email: ['',[Validators.pattern('[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+')]],
            emailNotification: false,
            selected : false,
            phoneNumber:''
        });
    }

    addProductionOffice(): void {

        let newPo = this.initProductionOffice(Guid.MakeNew().ToString());
        this.productionOffices.push(newPo);

    }

    addProductionContact(): void {
        let newPC = this.initProductionContacts();
        this.productionContacts.push(newPC);
    }

    addProjectContact(): void {
        let newPC = this.initProjectContactsAdded();
        this.projectContacts.push(newPC);
        
    }

    resetDefaultRecord(control: FormArray, defaultField: string, currentIndex) {
        if (control.value[currentIndex].id === this.projectForm.get(defaultField).value) {
            if (control.length > 1) {
                this.projectForm.get(defaultField).patchValue(control.value[currentIndex + 1].id);
            }
        }

    }
    removeProductionOffice(i: number): void {
        const control = <FormArray>this.projectForm.controls['productionOffices'];
        this.resetDefaultRecord(control, 'defaultProductionOffice', i);
        control.removeAt(i);
        this.projectForm.markAsDirty();
    }

    removeProductionContact(i: number): void {
        const control = <FormArray>this.projectForm.controls['productionContacts'];
        this.resetDefaultRecord(control, 'defaultProductionContact', i);
        control.removeAt(i);
        this.projectForm.markAsDirty();
    }

    removeProjectContact(i: number): void {
        const control = <FormArray>this.projectForm.controls['projectContacts'];
        this.resetDefaultRecord(control, 'defaultProjectContact', i);
        control.removeAt(i);
        this.projectForm.markAsDirty();
    }

    ProductionOfficeSelected(selectedItem) {
        console.log('ProjectDetailComponent.ProductionOfficeSelected(selectedItem:) ' + JSON.stringify(selectedItem.value.id));
        // selectedItem.controls.primary.checked = true;
        this.currentProductionOffice = selectedItem.value.id;
        this.projectForm.controls.defaultProductionOffice.setValue(selectedItem.value.id);
        console.log('ProjectDetailComponent >> defaultProductionOffice: ' + this.projectForm.controls.defaultProductionOffice.value);

    }

    ProductionContactSelected(selectedItem) {
        console.log('ProjectDetailComponent.ProductionContactSelected(selectedItem:) ' + JSON.stringify(selectedItem.value.id));
        // selectedItem.controls.primarypc.checked = true;
        this.currentProductionContact = selectedItem.value.id;
        this.projectForm.controls.defaultProductionContact.setValue(selectedItem.value.id);
        console.log('ProjectDetailComponent >> defaultProductionContact: ' + this.projectForm.controls.defaultProductionContact.value);

    }

    ProjectContactSelected(selectedItem) {
        
        console.log('ProjectDetailComponent.ProjectContactSelected(selectedItem:) ' + JSON.stringify(selectedItem.value.id));
        // selectedItem.controls.primary.checked = true;
        this.currentProjectContact = selectedItem.value.id;
        this.projectForm.controls.defaultProjectContact.setValue(selectedItem.value.id);
        console.log('ProjectDetailComponent >> defaultProjectContact: ' + this.projectForm.controls.defaultProjectContact.value);

    }

    initMaterial() {
        Materialize.updateTextFields();
    }

    getProject(id: string): void {
        this._projectService.getProject(id)
            .subscribe(
            (project: IProject) => this.onProjectRetrieved(project),
            (error: any) => {
                this.errorMessage = <any>error;
                this._errorHandler.processError(error);
            }
            );

    }

    getLookups(): void {
        this._projectService.getLookups()
            .subscribe(
            (titles: ILookup[]) => {
                
                this.titles = titles;
            },
            (error: any) => {
                this.errorMessage = <any>error;
                this._errorHandler.processError(error);
            }
            );

    }

    saveProject(): void {
        
        if (this.projectForm.dirty && this.projectForm.valid) {
            // Copy the form values over the product object values
            let p = <IProject>Object.assign({}, this.project, this.projectForm.value);
            var datePipe = new DatePipe('en-US');

            var isNew: boolean = (p.id === '');

            p.startDate = p.startDate ? datePipe.transform(p.startDate, 'yyyy-MM-dd') : p.startDate;
            p.wrapDate = p.wrapDate ? datePipe.transform(p.wrapDate, 'yyyy-MM-dd') : p.wrapDate;
            p.releaseDate = p.releaseDate ? datePipe.transform(p.releaseDate, 'yyyy-MM-dd') : p.releaseDate;

            this._projectService.saveProject(p)
                .subscribe(
                (p) => this.onSaveComplete(p, isNew),
                (error: any) => {
                
                    var e = JSON.stringify(error);
                    if(e.indexOf("AntiXssMiddleware") !== -1 || error.includes("AntiXssMiddleware")){
                        this._notificationsService.add(new Notification('error', this._errorHandler.xssMessage));                     
                    }else{
                        this.errorMessage = <any>error;
                        this._errorHandler.processError(error);
                    }
                });
        } else if (!this.projectForm.dirty) {
            //this should not be
            this.onSaveComplete(null, false);
        }
    }

    deleteProject(id: string): void {
        this._projectService.deleteProject(id)
            .subscribe(
            (r) => {
                if (r) {
                    console.log('projectDetailComponent.deleteProject(...) >> response: ' + JSON.stringify(r));
                    this.onDeleteComplete(id);
                }
                (error: any) => {
                    // console.error('projectDetailComponent.deleteProject(...) >> error:' + error);
                    this.errorMessage = <any>error;
                    this._errorHandler.processError(error);                    
                }
            }
            );

    }

    onProjectRetrieved(project: IProject): void {
        
        let productionOffices = <FormArray>this.projectForm.controls['productionOffices'];
        let productionContacts = <FormArray>this.projectForm.controls['productionContacts'];
        let projectContacts = <FormArray>this.projectForm.controls['projectContacts'];

        if (this.projectForm) {
            this.projectForm.reset();
            //reinit these values 
            this.currentProductionOffice = Guid.MakeNew().ToString();
            this.currentProductionContact = Guid.MakeNew().ToString();
            productionOffices.controls.pop();
            productionContacts.controls.pop();
            projectContacts.controls.pop();
        }

        if (!project) {
            this.error = 'Could not find project. It may have been deleted (or deactivated)!';
            this._errorHandler.processError(this.error);            
            return;
        }


        this.titles = this._projectService.titles;

        this.project = project;

        this.pageTitle = `Project: ${this.project.name}`;

        this.SaveLabel = 'Save Changes';
        this.projectForm.get('department').setValue(project.department);

        this.projectForm.controls.name.clearAsyncValidators();
        this.projectForm.controls.name.setAsyncValidators(ProjectValidator.checkProjectName(false, this.project.name));

        this.projectForm.controls.keyCode.clearAsyncValidators();
        this.projectForm.controls.keyCode.setAsyncValidators(ProjectValidator.checkProjectName(true, this.project.keyCode));

        // Update the data on the form
        this.projectForm.patchValue({
            id: this.project.id,
            name: this.project.name,
            keyCode: this.project.keyCode,
            wprBillingCode: this.project.wprBillingCode,
            comments: this.project.comments,
            startDate: DateUtils.toDateFromString(this.project.startDate, 0, 1, 2, 'MM-dd-yyyy', '-'),
            wrapDate: DateUtils.toDateFromString(this.project.wrapDate, 0, 1, 2, 'MM-dd-yyyy', '-'),
            releaseDate: DateUtils.toDateFromString(this.project.releaseDate, 0, 1, 2, 'MM-dd-yyyy', '-'),
            defaultProductionOffice: this.project.defaultProductionOffice ? this.project.defaultProductionOffice : this.currentProductionOffice,
            defaultProductionContact: this.project.defaultProductionContact ? this.project.defaultProductionContact : this.currentProductionContact,
            defaultProjectContact: this.project.defaultProjectContact ? this.project.defaultProjectContact : this.currentProjectContact//,

        });

        //push a new default production office if none found on the project itself
        if (this.project.productionOffices.length == 0) {
            let defaultPO = new IPRoductionOffice();
            defaultPO.id = this.currentProductionOffice;
            this.project.productionOffices.push(defaultPO);
        }

        //if so, init the array
        this.project.productionOffices.forEach(po => {
            const fb = this.initProductionOffice();
            fb.patchValue(po);
            productionOffices.push(fb);
        });

        if (this.project.productionContacts.length == 0) {
            let defaultPC = new IProductionContact();
            defaultPC.id = this.currentProductionContact;
            this.project.productionContacts.push(defaultPC);
        }


        this.project.productionContacts.forEach(app => {
            const fb = this.initProductionContacts();
            fb.patchValue(app);
            productionContacts.push(fb);
        });

        if (this.project.projectContacts.length == 0) {
            let defaultPCo = new IProjectContact();
            defaultPCo.id = this.currentProjectContact;
            
            this.project.projectContacts.push(defaultPCo);
        }

        this.project.projectContacts.forEach(app => {
            const fb = this.initProjectContacts();
             
            if(!(app.title === "Clearance Contact")){
                app.selected = true;
                app.emailNotification= false;
            }
            fb.patchValue(app);
            
            projectContacts.push(fb);
        });

        if (this.documents && this.project.documents && this.project.documents.length > 0) {
            this.project.documents.forEach(doc => {
                var existingImage = this.documents.find(it => it.id == doc.id);
                this.documents.push(doc);
            });
        }

        let docs = <FormArray>this.projectForm.controls['documents']

        if (docs && docs.controls && docs.controls.length > 0) {
            docs.controls = [];
        }
        if (this.documents)
            this.documents.forEach(doc => {
                const fb = this.documentComponent.initAsset(doc);
                fb.patchValue(doc);
                docs.push(fb);
            });
        docs.updateValueAndValidity();


        this.projectForm.controls.name.updateValueAndValidity();
        this.pageTitle = '';
        this.projectForm.patchValue({
            documents: this.documentComponent.initAssets()
        })
        this.initMaterial();

    }

    onSaveComplete(newProject: IProject, isNew: boolean): void {

        
        if (!newProject) {
            console.log('Error');
            return;
        }

        console.log('ProjectDetailComponent.OnSaveComplete >> saved project:' + JSON.stringify(newProject));

        this.projectForm.markAsPristine();

        this._router.navigate(['dashboard', newProject.id]);
        this._notificationsService.add(new Notification('success', newProject.name + ' was ' + (isNew ? 'added' : 'updated') + ' successfully'));
        
        this._messageBrokerService.setCurrentProject(new ProjectItem(newProject.id, newProject.name));

    }

    onDeleteComplete(id: string): void {

        // console.log('ProjectDetailComponent.onDeleteComplete() >>> finish');

        $('.main-container').addClass('animated hinge');
        let self = this;
        $('.main-container').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function () {
            //notifies that this project has been deleted (to be removed from the nav bar, etc.)
            self._messageBrokerService.setDeletedProject(id);
            self._router.navigate(['dashboard']);
            self._notificationsService.add(new Notification('success', 'Project \'' + self.project.name + '\' has been successfully deleted'));
        });
    }

    getDepartments(id: string): void {
        this._userDepartmentService.getDepartments()
            .subscribe(
            (userDepartments: IUserDepartment) => {
                this.userDepartments = userDepartments.userDepartments;
                if (!id) {                
                    this.projectForm.get('department').setValue(this.userDepartments[0].department);
                }
            },
            (error: any) => {
                this.errorMessage = <any>error;
                this._errorHandler.processError(error);
            }
            );
    }
   
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/project/project-detail.component.ts